module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('toggle-button', {
    attrs: {
      "sync": true,
      "value": _vm.value,
      "height": _vm.getHeight,
      "width": _vm.getWidth,
      "labels": {
        checked: _vm.t(_vm.config.labels.checked),
        unchecked: _vm.t(_vm.config.labels.unchecked)
      }
    },
    on: {
      "change": _vm.change
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7bdd4cb6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToggleButtonComponent.vue
// module id = 1330
// module chunks = 2